var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoCameraOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2982 3.70176L15.5789 6H18C19.2281 6 20 6.77193 20 8V16C20 17.2281 19.2281 18 18 18H6C4.77193 18 4 17.2281 4 16V8C4 6.77193 4.77193 6 6 6H8.42105L10.7018 3.70176C10.8947 3.52632 11 3.2807 11 3C11 2.45614 10.5439 2 10 2C9.7193 2 9.47369 2.10526 9.29825 2.29825L7.57895 4H6C3.78947 4 2 5.78947 2 8V16C2 18.2105 3.78947 20 6 20H18C20.2105 20 22 18.2105 22 16V8C22 5.78947 20.2105 4 18 4H16.4211L14.7018 2.29825C14.5263 2.10526 14.2807 2 14 2C13.4561 2 13 2.45614 13 3C13 3.2807 13.1053 3.52632 13.2982 3.70176ZM12 9C13.7895 9 15 10.2105 15 12C15 13.7895 13.7895 15 12 15C10.2105 15 9 13.7895 9 12C9 10.2105 10.2105 9 12 9ZM12 7C9.22807 7 7 9.22807 7 12C7 14.7719 9.22807 17 12 17C14.7719 17 17 14.7719 17 12C17 9.22807 14.7719 7 12 7ZM10 4H14C14.5439 4 15 3.54386 15 3C15 2.45614 14.5439 2 14 2H10C9.45614 2 9 2.45614 9 3C9 3.54386 9.45614 4 10 4Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCameraOutlined);
export default __webpack_public_path__ + "static/media/photo_camera_outlined.b5bd834b.svg";
export { ForwardRef as ReactComponent };